"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutOrderingKeys = void 0;
var LayoutOrderingKeys;
(function (LayoutOrderingKeys) {
    LayoutOrderingKeys["AUTHOR_ROW"] = "author_row";
    LayoutOrderingKeys["TEXT_BODY"] = "text_body";
    LayoutOrderingKeys["MEDIA_GALLERY"] = "media_gallery";
    LayoutOrderingKeys["ATTACHMENTS"] = "attachments";
    LayoutOrderingKeys["ACTIVITY_BAR"] = "activity_bar";
    LayoutOrderingKeys["LAYOUT"] = "layout";
    LayoutOrderingKeys["FOOTER_ATTACHMENTS"] = "footer_attachments";
})(LayoutOrderingKeys = exports.LayoutOrderingKeys || (exports.LayoutOrderingKeys = {}));
